<template>
  <div class="navbar-header text-center">
    <div class="col-12">
      <img @click="$router.push('/')" :src="require('@/assets/images/banner.png')" style="height: 40px; margin: auto 0px; position: relative;">
    </div>
  </div>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style>

</style>
